<template>
  <div class="basket-sub-item full-width">
    <div class="row q-col-gutter-sm">
      <div class="col-3">
        <div v-if="product && product.IMAGE?.SRC" @click="onClick" class="cursor-pointer">
          <img
              v-if="product"
              :src="imageResolve(product.IMAGE?.SRC, 100)"
          />
        </div>
      </div>
      <div class="col-18">
        <div class="cursor-pointer" @click="onClick">
          <div
              class="s-font-xs text-weight-medium"
              :class="{
                    'text-primary': reasonModificator?.TYPE === 'gift'
                  }"
          >
            {{ productName }}
            <span v-if="reasonModificator?.TYPE === 'gift'" class="text-no-wrap">
              в подарок
              <q-icon
                  :name="ICONS.promocode"
                  color="primary"
                  class="q-pl-xs"
              />
            </span>
          </div>
        </div>
      </div>
      <div class="col-3">
        <span v-if="!quantityEditable" class="s-font-xs q-pl-xs text-no-wrap">
          x {{ item.fields.QUANTITY }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

import {useVorderStore} from "@/modules/shop/store/vorder";

import {computed, toRefs} from "vue";
import {useImager} from "@/core/store/imager";
import {useCurrency} from "@/modules/shop/store/currency";
import {useRouter} from "vue-router";
import toInt from "@/core/util/toInt";
import {useBasketStore} from "@/modules/shop/store/basket";
import {useVorderTotalStore} from "@/modules/shop/store/vorder-total";
import {BasketItemModel} from "@/modules/shop/composable/util";
import {ICONS} from "@/assets/icons";

const basketStore = useBasketStore()
const totalStore = useVorderTotalStore()
const router = useRouter()
const {imageResolve} = useImager()
const {formatPrice} = useCurrency()
const {basketOp} = basketStore

type BasketItemProps = {
  item: BasketItemModel
}

const props = withDefaults(defineProps<BasketItemProps>(), {})

const {item} = toRefs(props)

const productId = computed(() => item.value.fields.PRODUCT_ID)
const product = computed(() => item.value.product)
const productName = computed(() => product.value ? product.value.NAME : item.value.fields.NAME)
const children = computed(() => item.value.children)

// Получаем calc из calculatorStore
const calc = computed(() => {
  return totalStore.basketItemsCalculatedById[item.value.id]?.calc || {
    price: 0,
    priceSource: 0,
    priceTotal: 0,
    priceTotalSource: 0,
    discountPercent: 0
  };
})

const onClick = () => {
  if (product.value) {
   // router.push('/product/' + productId.value)
  }
}

const onQuantityUpdate = (value: number) => {
  value = toInt(value)
  if (value >= 0) {
    basketOp({
      action: 'quantity',
      productId: productId.value,
      quantity: value,
    })
  }
}

const reasonModificator = computed(() => item.value.getReasonModificator())

const quantityEditable = computed(() => {
  return false
})

const showPrice = computed(() => {
  return reasonModificator.value?.TYPE !== 'gift'
})


</script>

<style scoped lang="scss">


.c-image {

}

.basket-sub-item1 {


  .node-line {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
  }

  /* Вертикальная линия для всех узлов */
  .node-line::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    height: 100%;
    border-left: var(--line-width) solid var(--line-color);
  }

  /* Горизонтальная соединительная линия */
  .node-line::after {
    content: '';
    position: absolute;
    top: calc(var(--node-gutter-y) + 10px);
    left: 50%;
    width: 100%;
    border-top: var(--line-width) solid var(--line-color);
  }

  /* Для последнего узла в группе - укорачиваем вертикальную линию */
  &:last-child .node-line::before {
    height: calc(var(--node-gutter-y) + 10px);
  }

  /* Для одиночных узлов (и первый и последний одновременно) */
  &:first-child:last-child .node-line::before {
    height: calc(var(--node-gutter-y) + 10px);
  }
}


</style>
